import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[cxFrozenColumn]',
})
export class FrozenColumnDirective implements AfterViewInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    const left = this.getLeft();
    this.renderer.setStyle(this.el.nativeElement, 'position', 'sticky');
    this.renderer.setStyle(this.el.nativeElement, 'left', `${left}px`);
  }

  private getLeft(): number {
    const el = this.el.nativeElement;
    const parent = el.offsetParent;

    if (!parent) {
      return 0;
    }

    return el.offsetLeft;
  }
}
